import React from 'react';

const COUNTRIES = [
  '🇸🇦 Saudi Arabia','🇮🇳 India','🇦🇺 Australia','🇺🇸 United States',
  '🇳🇱 Netherlands','🇯🇵 Japan','🇳🇴 Norway','🇨🇳 China',
];

export default function Proof() {
  return (
    <section className="proof">
      <div className="container">
        <p className="proof-label">Trusted by global workforce teams placing contractors in</p>
        <div className="country-pills">
          {COUNTRIES.map(c => <span key={c}>{c}</span>)}
        </div>
      </div>
    </section>
  );
}
